import React, { useState, useReducer } from "react"
import location from "../../../assets/icons/location.svg"
import people from "../../../assets/icons/people.svg"
import budgetIcon from "../../../assets/icons/budget.svg"
import styles from "./Filtering.scss"
import DateRangePicker from "../DateRangePicker/DateRangePicker"
import { MultipleSelect } from ".."

interface IProps {
  categories: [string]
  selectedCategories: [string]
  numberOfPeople: number
  startDate: Date
  endDate: Date
  budget: number
  setNumberOfPeople: (numberOfPeople: number) => void
  setBudget: (budget: number) => void
  setSelectedCategories: (category: string) => void
  setSearchedLocation: (location: { lat: number; lng: number }) => void
  setStartDate: (date: Date) => void
  setEndDate: (date: Date) => void
  onSearch: () => void
}

const Filtering = ({
  categories,
  budget,
  numberOfPeople,
  setBudget,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  setNumberOfPeople,
  setSelectedCategories,
  setSearchedLocation,
  selectedCategories,
  searchedLocation = { lat: "", lgn: "", description: "" },
  onSearch,
}: IProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  function suggestSelectHandler(e) {
    setSearchedLocation(e.target.value)
  }

  function onFocusHandler() {
    setIsOpen(true)
  }

  function onBlurHandler() {
    setIsOpen(false)
  }

  function renderIconedInput(icon, input, id?: string) {
    return (
      <div key={id} id={id}>
        {icon}
        {input}
      </div>
    )
  }
  return (
    <div
      className={[styles.container, !isOpen && styles.container__closed].join(
        " "
      )}
    >
      <div>
        {renderIconedInput(
          <img src={location} alt="location" />,
          <input placeholder="Où ?" onChange={suggestSelectHandler} />,
          "geo"
        )}
        <MultipleSelect
          options={categories}
          selectedOptions={selectedCategories}
          setSelectedCategories={setSelectedCategories}
        />
        {renderIconedInput(
          <img src={people} alt="people" />,
          <select
            id="peopleNumber"
            onChange={(e: React.ChangeEvent<HTMLSelectEvent>) =>
              setNumberOfPeople(e.target.value)
            }
            defaultValue="default"
            value={numberOfPeople}
          >
            <option value="default">Nombre de personnes</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="Tous">Peu importe</option>
          </select>,
          "peopleNumber"
        )}
        {renderIconedInput(
          <img src={budgetIcon} alt="price" />,
          <input
            id="price"
            type="number"
            onChange={(e: React.ChangeEvent<HTMLInputEvent>) =>
              setBudget(e.target.value)
            }
            value={budget}
            placeholder="Budget"
          />,
          "price"
        )}
        <DateRangePicker
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          startDate={startDate}
          endDate={endDate}
        />
        <button onClick={onSearch}>GO !</button>
      </div>
    </div>
  )
}

export default Filtering
